export default "__VITE_ASSET__OKMdYKCy__"